import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  profilelist: [], // Store the entire API response here
};

const ProfileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    Profilehistry: (state, action) => {
      state.profilelist = action.payload; // Store the entire API response
    },
  },
});

export const { Profilehistry } = ProfileSlice.actions;
export default ProfileSlice.reducer;